import { api } from '@/lib/api';

export type ModelRouterModelInfo = {
  id: string;
  supports_chat?: boolean;
  supports_embeddings?: boolean;
  supports_transcription?: boolean;
  supports_tts?: boolean;
  supports_image_generation?: boolean;
  supports_image_input?: boolean;
  supports_audio_input?: boolean;
  modalities?: string[];
};

export const MODELROUTER_DEFAULT_BASE_URL = 'https://router.leftclick.ch/v1';

export function filterRouterModels(
  models: ModelRouterModelInfo[],
  filter: 'chat' | 'transcription' | 'all'
): ModelRouterModelInfo[] {
  if (filter === 'all') return models;
  if (filter === 'chat') return models.filter((m) => m.supports_chat);
  if (filter === 'transcription') return models.filter((m) => m.supports_transcription);
  return models;
}

export function modelRouterModalityLabel(m: ModelRouterModelInfo): string {
  const parts: string[] = [];
  if (m.supports_chat) parts.push('Chat');
  if (m.supports_embeddings) parts.push('Embeddings');
  if (m.supports_transcription) parts.push('STT');
  if (m.supports_tts) parts.push('TTS');
  if (m.supports_image_generation) parts.push('Bild');
  return parts.length ? parts.join(', ') : 'Modell';
}

/** Live models from configured credential (admin or app). */
export async function fetchLiveModelRouterModels(): Promise<ModelRouterModelInfo[]> {
  const res = await api.get<{ success?: boolean; data?: { models?: ModelRouterModelInfo[] }; error?: string }>(
    '/ai/modelrouter/models'
  );
  if (res.success === false || !res.data?.models) {
    throw new Error((res as { error?: string }).error || 'Modelle konnten nicht geladen werden');
  }
  return res.data.models;
}

/** Draft or saved credential (admin only). */
export async function fetchAdminModelRouterModels(input: {
  credential_id?: string;
  config?: Record<string, unknown>;
  credentials?: Record<string, unknown>;
}): Promise<ModelRouterModelInfo[]> {
  const res = await api.post<{ success?: boolean; data?: { models?: ModelRouterModelInfo[] }; error?: string }>(
    '/admin/modelrouter/models',
    input
  );
  if (res.success === false || !res.data?.models) {
    throw new Error((res as { error?: string }).error || 'Modelle konnten nicht geladen werden');
  }
  return res.data.models;
}
